import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M26.869 22.927a.98.98 0 0 1-.31.74l-2.893 2.892a.97.97 0 0 1-.738.31h-.001a.98.98 0 0 1-.74-.31L15.92 20.29l-.707-.707-.707.707-6.268 6.268a.98.98 0 0 1-.738.31.98.98 0 0 1-.74-.31l-2.893-2.893a.98.98 0 0 1-.31-.739c0-.294.094-.523.31-.739l6.268-6.268.707-.707-.707-.707-6.268-6.268a.98.98 0 0 1-.31-.739c0-.294.094-.522.31-.739L6.76 3.867a.98.98 0 0 1 .74-.31c.294 0 .522.094.739.31l6.267 6.268.707.707.707-.707 6.268-6.268a.98.98 0 0 1 .74-.31c.293 0 .522.094.738.31L26.56 6.76c.216.216.31.445.31.739a.98.98 0 0 1-.31.74l-6.268 6.267-.707.707.707.707 6.268 6.268c.216.216.31.445.31.74Z"
    }, null, -1)
  ]))]))
}
export default { render: render }